/**
 * StatCard — the §7.6 stat card on run history, the estimate and the catalog
 * (mission 6 WP03 T023; FR-005, NFR-007).
 *
 * A compact card: the label in overline navy-600, the value in `--text-stat`
 * navy-950 (mono when it is a count beside other counts), an optional caption
 * footnote. Loading shows a skeleton in the value's place. Every string is a
 * prop.
 */
import type { ReactNode } from 'react'

import { Card } from '@/components/ui/card'
import { cn } from '@/components/ui/cn'
import { Skeleton } from '@/components/ui/skeleton'

export interface StatCardProps {
  label: ReactNode
  value: ReactNode
  mono?: boolean
  footnote?: ReactNode
  loading?: boolean
}

export function StatCard({ label, value, mono = false, footnote, loading = false }: StatCardProps) {
  return (
    <Card padding="compact">
      <p className="text-overline uppercase text-navy-600">{label}</p>
      {loading ? (
        <Skeleton className="mt-1 h-8 w-24" />
      ) : (
        <p className={cn('mt-1 text-stat text-navy-950', mono && 'font-mono')}>{value}</p>
      )}
      {footnote ? <p className="mt-1 text-caption text-navy-600">{footnote}</p> : null}
    </Card>
  )
}
